// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let SystemMessage = require("../common/Components/SystemMessage.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedProfileSave_updatedAgent_graphql = require("../../__generated__/UnifiedProfileSave_updatedAgent_graphql.bs.js");
let UnifiedProfileSave_updatedMembers_graphql = require("../../__generated__/UnifiedProfileSave_updatedMembers_graphql.bs.js");
let UnifiedProfileSave_updatedAccountProfile_graphql = require("../../__generated__/UnifiedProfileSave_updatedAccountProfile_graphql.bs.js");
let UnifiedProfileSaveProfessionalInfoMutation_graphql = require("../../__generated__/UnifiedProfileSaveProfessionalInfoMutation_graphql.bs.js");

let convertVariables = UnifiedProfileSaveProfessionalInfoMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedProfileSaveProfessionalInfoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedProfileSaveProfessionalInfoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedProfileSaveProfessionalInfoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedProfileSaveProfessionalInfoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let ProfessionalInfoMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertFragment = UnifiedProfileSave_updatedAccountProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedProfileSave_updatedAccountProfile_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedProfileSave_updatedAccountProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedProfileSave_updatedAccountProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(UnifiedProfileSave_updatedAccountProfile_graphql.node, convertFragment, fRef);
}

let UpdatedAccountProfile = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = UnifiedProfileSave_updatedMembers_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedProfileSave_updatedMembers_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedProfileSave_updatedMembers_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedProfileSave_updatedMembers_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(UnifiedProfileSave_updatedMembers_graphql.node, convertFragment$1, fRef);
}

let UpdatedMembers = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = UnifiedProfileSave_updatedAgent_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedProfileSave_updatedAgent_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedProfileSave_updatedAgent_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedProfileSave_updatedAgent_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(UnifiedProfileSave_updatedAgent_graphql.node, convertFragment$2, fRef);
}

let UpdatedAgent = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function UnifiedProfileSave$Feedback(props) {
  let message = props.message;
  if (message === undefined) {
    return null;
  }
  let onDismiss = props.onDismiss;
  if (message.TAG === "Ok") {
    return JsxRuntime.jsx(Alert.Success.make, {
      title: message._0
    });
  } else {
    return JsxRuntime.jsx(SystemMessage.make, {
      id: "profile_saved",
      time: 5000,
      text: message._0,
      type_: "error",
      dismissible: true,
      secondary: true,
      handleOnDismiss: param => onDismiss()
    });
  }
}

let Feedback = {
  make: UnifiedProfileSave$Feedback
};

function useAccountSave(saving, commit, extract) {
  let match = React.useState(() => {});
  let setMessage = match[1];
  let save = (input, onSuccess, onFailure) => {
    setMessage(param => {});
    let onFailure$1 = message => {
      setMessage(param => ({
        TAG: "Error",
        _0: message
      }));
      return onFailure(message);
    };
    commit(input, (response, param) => {
      let value = extract(response);
      if (value.TAG !== "Ok") {
        return onFailure$1(value._0);
      }
      setMessage(param => ({
        TAG: "Ok",
        _0: "Account updated"
      }));
      return onSuccess(value._0);
    }, param => onFailure$1("Your changes could not be saved. Please try again."));
  };
  let feedback = JsxRuntime.jsx(UnifiedProfileSave$Feedback, {
    message: match[0],
    onDismiss: () => setMessage(param => {})
  });
  return [
    save,
    saving,
    feedback
  ];
}

function usePersonalProfessionalInfo() {
  let match = use();
  let commit = match[0];
  return useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedProfessionalInfo;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "Your changes could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UnifiedPersonalProfileUpdated" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "UnifiedProfileUpdateFailed" :
        return {
          TAG: "Error",
          _0: match.message
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "Your changes could not be saved. Please try again."
        };
    }
  });
}

function fromPhoto(photo) {
  return {
    contentType: photo.contentType,
    fileName: photo.fileName,
    key: photo.key,
    uploadId: photo.id
  };
}

exports.ProfessionalInfoMutation = ProfessionalInfoMutation;
exports.UpdatedAccountProfile = UpdatedAccountProfile;
exports.UpdatedMembers = UpdatedMembers;
exports.UpdatedAgent = UpdatedAgent;
exports.Feedback = Feedback;
exports.useAccountSave = useAccountSave;
exports.usePersonalProfessionalInfo = usePersonalProfessionalInfo;
exports.fromPhoto = fromPhoto;
/* commitMutation Not a pure module */
